module.exports = __webpack_public_path__ + "img/image165.ac9a81c1.png";